import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const wingitnorthListLocationGuestKpisConfigs = {
  smgDigitalTotal: 'number',
  smgDigitalPercent: 'percent',
  smgNonDigitalTotal: 'number',
  smgNonDigitalPercent: 'percent',
  smgDeliveryTotal: 'number',
  smgDeliveryPercent: 'percent',
  smgQscCount: 'number',
  smgQscScore: 'number',
  smgTrainingCompletion: 'number',
  smgTrainingCompletionPercent: 'percent',
  smgDissatisfaction: 'number',
  smgDissatisfactionPercent: 'percent',
  smgAccurate: 'number',
  smgAccuratePercent: 'percent',
} as const

const useWingitnorthListLocationGuestKpis = buildMetricValuesHook({
  groupFilterType: 'store',
  metrics: {
    groups: ['Expo Module - SMG'],
  },
})

export default useWingitnorthListLocationGuestKpis
